import { Grid } from '@material-ui/core'

import {
  EntitySwitch,
  EntityOrphanWarning,
  EntityProcessingErrorsPanel,
  hasCatalogProcessingErrors,
  isOrphan
} from '@backstage/plugin-catalog'

import { EntityPatchedNotice } from './EntityPatchedNotice'
import { isPatchedEntity } from './catalogPatchAnnotations'

export function EntityWarningContent() {
  return (
    <>
      <EntitySwitch>
        <EntitySwitch.Case if={isOrphan}>
          <Grid item xs={12}>
            <EntityOrphanWarning />
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>

      <EntitySwitch>
        <EntitySwitch.Case if={hasCatalogProcessingErrors}>
          <Grid item xs={12}>
            <EntityProcessingErrorsPanel />
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>

      {/* Not a warning — see EntityPatchedNotice. It lives here because this is
          the single banner insertion point that covers every kind. */}
      <EntitySwitch>
        <EntitySwitch.Case if={isPatchedEntity}>
          <Grid item xs={12}>
            <EntityPatchedNotice />
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>
    </>
  )
}
